// routes/_shop.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_shop')

export const handle = {
  name: 'shop-layout',
  track: () => ({
    scene: 'shop',
  }),
}

export default dynamic(getClientModule, { ssr: false })
